<template>
  <v-container fluid class="b-container">
    <v-sheet class="pa-3" color="rgba(234, 237, 241, 0.57)">
      <v-row>
        <v-col md="12" v-if="superUser">
          <ShowLoyalty />
        </v-col>

        <v-col md="6">
          <Logo />
          <PinDisplay />
          <PointsRelation />
          <PrivacyPolicy />
          <PointsReturn />
          <PushNotifications />
          <SmsConfiguration />
          <UserPointsInApp />
          <Tiers v-if="getPermission('settings.point_titles.read')" />
          <CouponCreation />
          <PointExpiration />
          <ViberConfiguration />
          <DisplayMode v-if="superUser" />
        </v-col>

        <v-col md="6">
          <LoyaltyLogo />
          <PinDisplayHours />
          <UserManual />
          <TermsOfUse />
          <InitialPoints />
          <CampaignCredentials />
          <EmailConfiguration />
          <SmsRedemption />
          <CouponClaimValidDays />
          <CompanyName />
          <TinElorus />
        </v-col>
        <v-col v-if="superUser" md="12" class="d-flex justify-center pa-0 pb-1">
          <v-btn
            class="pa-4"
            style="
              text-transform: unset;
              border-radius: 8px;
              font-size: 1.125rem !important;
              background-color: rgb(204, 37, 37) !important;
            "
            elevation="4"
            block
            color="error"
            @click="deleteDialog = true"
            ><span style="font-size: 1.125rem !important" class="text-h4">{{
              translations.deleteCompany[lang]
            }}</span></v-btn
          >
          <v-dialog
            v-model="deleteDialog"
            :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '60%'"
          >
            <b-card
              type="delete"
              :title="translations.deleteCompany[lang]"
              :submit-text="translations.delete"
              :loading="loading"
              @cancel="deleteDialog = false"
              @submit="startDeleteCompany()"
            >
              <div class="subtitle-1 font-weight-medium pt-2 px-2">
                {{ translations.deleteCompanyConfirmationMessage[lang] }}
              </div>
              <v-col>
                <v-simple-table>
                  <template v-slot:default>
                    <thead style="max-height: 1px">
                      <tr style="background: #eaedf1">
                        <th class="text-left" style="height: 1px">ID</th>
                        <th class="text-left" style="height: 1px">
                          {{ translations.name[lang] }}
                        </th>
                        <th class="text-left" style="height: 1px; max-width: 280px !important">
                          {{ translations.address[lang] }}
                        </th>
                        <th class="text-left" style="height: 1px">
                          {{ translations.primary_phone[lang] }}
                        </th>
                        <th class="text-left" style="height: 1px">
                          {{ translations.subscribed[lang] }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ companyId }}</td>
                        <td>
                          <span class="font-weight-bold px-1 d-flex align-center pr-0">
                            {{ companyName }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ company.address }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ company.primary_phone }}
                          </span>
                        </td>
                        <td>
                          <span>
                            <v-icon v-if="company.active_subscription" color="success"
                              >mdi-check-circle</v-icon
                            >
                            <v-icon v-else color="error">mdi-close-circle</v-icon>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </b-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
import Logo from '@/components/loyaltyPanel/businessProfile/Logo.vue';
import PinDisplay from '@/components/loyaltyPanel/businessProfile/PinDisplay.vue';
import PinDisplayHours from '@/components/loyaltyPanel/businessProfile/PinDisplayHours.vue';
import UserManual from '@/components/loyaltyPanel/businessProfile/UserManual.vue';
import PointsRelation from '@/components/loyaltyPanel/businessProfile/PointsRelation.vue';
import TermsOfUse from '@/components/loyaltyPanel/businessProfile/TermsOfUse.vue';
import PrivacyPolicy from '@/components/loyaltyPanel/businessProfile/PrivacyPolicy.vue';
import InitialPoints from '@/components/loyaltyPanel/businessProfile/InitialPoints.vue';
// import InitialDigits from "@/components/loyaltyPanel/businessProfile/InitialDigits.vue";
import PushNotifications from '@/components/loyaltyPanel/businessProfile/PushNotifications.vue';
import CampaignCredentials from '@/components/loyaltyPanel/businessProfile/CampaignCredentials.vue';
import PointsReturn from '@/components/loyaltyPanel/businessProfile/PointsReturn.vue';
import CouponCreation from '@/components/loyaltyPanel/businessProfile/CouponCreation.vue';
import ApiAuthentication from '@/components/loyaltyPanel/businessProfile/ApiAuthentication.vue';
import UserPointsInApp from '@/components/loyaltyPanel/businessProfile/UserPointsInApp.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import SmsConfiguration from '../../components/loyaltyPanel/businessProfile/SmsConfiguration.vue';
import SmsRedemption from '../../components/loyaltyPanel/businessProfile/SmsRedemption.vue';
import EmailConfiguration from '../../components/loyaltyPanel/businessProfile/EmailConfiguration.vue';
import ShowLoyalty from '@/components/loyaltyPanel/businessProfile/ShowLoyalty.vue';
import LoyaltyLogo from '@/components/loyaltyPanel/businessProfile/LoyaltyLogo.vue';
import CouponClaimValidDays from '@/components/loyaltyPanel/businessProfile/CouponClaimValidDays.vue';
import Tiers from '@/components/loyaltyPanel/businessProfile/Tiers.vue';
import CompanyName from '@/components/loyaltyPanel/businessProfile/CompanyName.vue';
import PointExpiration from '@/components/loyaltyPanel/businessProfile/PointExpiration.vue';
import ViberConfiguration from '@/components/loyaltyPanel/businessProfile/ViberConfiguration.vue';
import TinElorus from '@/components/loyaltyPanel/businessProfile/TinElorus.vue';
import DisplayMode from '@/components/loyaltyPanel/businessProfile/DisplayMode.vue';

import translations from '@/utils/translations/global';

export default {
  name: 'BusinessProfile',
  mixins: [translations],

  components: {
    Logo,
    PinDisplay,
    UserManual,
    PointsRelation,
    TermsOfUse,
    PrivacyPolicy,
    InitialPoints,
    // InitialDigits,
    PushNotifications,
    CampaignCredentials,
    PointsReturn,
    CouponCreation,
    // ApiAuthentication,
    UserPointsInApp,
    SmsConfiguration,
    SmsRedemption,
    EmailConfiguration,
    PinDisplayHours,
    ShowLoyalty,
    LoyaltyLogo,
    CouponClaimValidDays,
    Tiers,
    PointExpiration,
    CompanyName,
    ViberConfiguration,
    TinElorus,
    DisplayMode,
  },

  data: () => ({
    deleteDialog: false,
  }),

  computed: {
    ...mapState(['superUser', 'loading']),
    errorMessages() {
      return this.$store.state.loyaltyPanel.businessProfile.errorMessage;
    },

    lang() {
      return this.$route.params.lang;
    },
    company() {
      return this.$store.state.loyaltyPanel.company;
    },
    companyName() {
      return this.$store.state.loyaltyPanel.company.name;
    },
    companyId() {
      return localStorage.getItem('storeId');
    },
  },
  methods: {
    ...mapMutations(['setNotification']),
    ...mapActions(['getPermission']),
    ...mapActions('loyaltyPanel/businessProfile', ['getBussinessProfile']),
    ...mapActions('loyaltyPanel', ['deleteCompany']),
    async startDeleteCompany() {
      let res = await this.deleteCompany();
      if (res && !res.error) {
        this.setNotification({
          show: true,
          type: 'success',
          text: this.translations.companyDeletedNotif?.[this.lang],
          timeout: 5000,
        });
        await this.$router.push({ name: 'UserStores' });
      } else {
        this.deleteDialog = false;
      }
    },
  },
  mounted() {
    this.$clearFocus();
    this.getBussinessProfile();
  },

  watch: {
    ['$store.state.loyaltyPanel.businessProfile.errorMessage']: {
      immediate: true,
      handler(val, oldVal) {
        if (val && oldVal) {
          for (let key in val) {
            if (val[key]) {
              this.setNotification({
                show: true,
                type: 'error',
                text: val[key],
              });
            }
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.dashed {
  border: 1px dashed grey;
  border-radius: 10px;
}

.relative {
  position: relative;
}

.map-new-pin {
  width: 50px;
  position: absolute;
  top: 37px;
  left: 14px;
}

.category-number {
  position: absolute;
  top: 7px;
  left: -5px;
}

.category-remove {
  position: absolute;
  top: -10px;
  right: -10px;
  cursor: pointer;
}
</style>
